import { useEffect, useState } from "react";
import { Output } from "valibot";

import { requestBackend } from "shared/request";

import { ChatUserFormFieldsSchema } from "./schemas";

function useChatUserFormFields(token: string) {
  const [chatUserFormFields, setChatUserFormFields] = useState<
    Output<typeof ChatUserFormFieldsSchema>
  >({
    data_fields: [],
  });
  const [chatUserFormFieldsUpdateTime, setChatUserFormFieldsUpdateTime] =
    useState(Date.now());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    requestBackend("/v1/botsonic/widget/chat-user-form-fields", {
      headers: {
        token,
      },
      schema: ChatUserFormFieldsSchema,
    })
      .then(
        newChatUserFormFields => setChatUserFormFields(newChatUserFormFields),
        err => {
          // eslint-disable-next-line no-console
          console.error(err);
        },
      )
      .finally(() => setLoading(false));
  }, [token, chatUserFormFieldsUpdateTime]);

  return {
    chatUserFormFields,
    setChatUserFormFields,
    setChatUserFormFieldsUpdateTime,
    loading,
    error,
  };
}

export default useChatUserFormFields;
